<template>
  <div class="srf-wrapper" :style="{ height: height }">
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    position: {
      type: String,
      default: "bottom",
    },
    height: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {};
  },
  mounted() {
    // this.sr().reveal(".srf-wrapper", {
    //   delay: 500, // 延迟 500 毫秒
    //   // distance: "100%", // 移动距离 50 像素
    //   duration: 1000, // 动画持续 1 秒
    //   origin: this.props, // 从底部进入
    //   easing: "ease-in-out", // 缓动效果
    //   reset: true, // 离开视口后重置动画
    //   opacity: 0, // 初始透明度为 0
    //   scale: 0.9, // 初始缩放为 90%
    // });
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
